import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@material-ui/core';
import { useMessages } from '../../contexts/messages';

import { PageError } from '../../models/common';

const Error = ({ type = PageError.NotFound }) => {
  const { setPageTitle } = useMessages();

  useEffect(() => {
    setPageTitle('Oops');
  }, [setPageTitle]);

  const isForbidden = type === PageError.Forbidden;
  return (
    <Box textAlign="center" component={Container} maxWidth="md" p={8}>
      <Typography variant="h1" color="primary">
        {isForbidden ? 'Forbidden' : '404 Not Found'}
      </Typography>
      <Box my={3}>
        {isForbidden ? (
          <Typography>You do not have access to this page.</Typography>
        ) : (
          <>
            <Typography>The page you requested could not be found.</Typography>
            <Typography>Please check the URL and try again.</Typography>
          </>
        )}
      </Box>
      <Button variant="contained" color="primary" component={Link} to="/">
        Return to Home
      </Button>
    </Box>
  );
};

export default Error;
